import { withTranslation } from "next-i18next";
import classNames from "classnames";
import { useButtonEventTracking } from "@hooks/use-button-event-tracking";
import IconSvg from "../IconSvg";

function CreateUserListCard({ onClick, trackingName, className, t }) {
  const trackEvent = useButtonEventTracking();

  function handleClick() {
    trackEvent(trackingName);

    onClick();
  }

  return (
    <button
      className="btn-transparent w-100"
      onClick={handleClick}
    >
      <div className={classNames("userlist-horizontal-card", className)}>
        <div className="userlist-horizontal-card-content">
          <div className="userlist-horizontal-card-infos">
            <p className="mb-0 font-weight-bold">{t("common:userlist.create")}</p>
            <p className="mb-0 font-size-sm">{t("common:userlist.order_them")}</p>
          </div>
          <div className="userlist-horizontal-card-actions create-btn">
            <div className="image-container">
              <IconSvg name="symbol-increase" />
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}

export default withTranslation("common")(CreateUserListCard);
